import { Section } from "anketa-core/group";
import { Translation } from "anketa-core/i18n";
import { QuestionsRightsTypes } from "..";
import {
  AnketaCheckPermissionOptions,
  AnketaResourcesEnum,
} from "../../../../";
import { getLdapRow } from "./ldap";
import { getOidcSection } from "./oidc";

export * from "./ldap";
export * from "./oidc";

export const opsanioAuth = (
  questionsRights: (
    q: QuestionsRightsTypes,
    options?: AnketaCheckPermissionOptions<AnketaResourcesEnum.questionnaires>,
  ) => void,
  defaultValues: boolean,
): Section => {
  const authSection: Section = new Section("auth", [
    new Translation("en", "Login methods"),
    new Translation("de", "Login-Methode"),
  ]);

  authSection.addChild(getOidcSection(defaultValues));
  authSection.addChild(getLdapRow(defaultValues));

  return authSection;
};
